module.exports = __webpack_public_path__ + "img/payment-processing.386b1ff.png";